// Modules
import React, { Component } from 'react';
import styled from 'styled-components';
import numeral from 'numeral';
import { connect } from 'react-redux';
import { translate } from 'react-translate';

// Components
import PreviewModal from '@components/PreviewModal/PreviewModal';
import EditModal from '@components/EditModal/EditModal';
import EllipsisButton from '@containers/Scope/MediasCenter/pages/Feed/EllipsisButton';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Utils
import { handleValueTooBig } from '@utils/helpers';
import dayjs from 'dayjs';

const Wrapper = styled('div')`
  ${({ theme }) => `
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: ${theme.spacing.px10} ${theme.spacing.px10} 0;

        p, svg {
            color: ${theme.colors.blueGrey2};
            font-size: ${theme.fontSize.px14};
        }
    `}
`;

const Info = styled('div')`
  ${({ theme, full, idAd, isInstagram }) => `
        width: 75%;
        background: white;
        border-radius: 10px;
        border: 1px solid #ccc;
        padding: 14px 24px;
        .first-content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            ${
              isInstagram
                ? `
                    justify-content: flex-start;
                    > div {
                        margin: 0 10px;
                    }

            `
                : ''
            }
            font-size:12px;
            color: #0C2833;
            ${idAd ? `margin-bottom: ${theme.spacing.px10};` : ''}
            div:nth-last-child(1) {
                p {
                    color: ${theme.colors.blue2};
                    cursor: pointer;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
            div {
                display: flex;
                align-items: center;
            }
            svg {
                margin-right: ${theme.spacing.px10}
            }
        }
        .last-content {
            text-align: center;
        }
        ${
          full
            ? `
                width: 100%;
            `
            : ''
        }
    `}
`;

const AdDataWrapper = styled('div')`
  display: flex;
  font-size: 12px;
  color: #0c2833;
  justify-content: space-between;
`;

const SecondContentWrapper = styled('div')`
  ${({ theme }) => `
        display:flex;
        font-size:${theme.fontSize.px12};
        color: ${theme.colors.blueGrey1};
        justify-content: flex-start;
        margin-top: ${theme.spacing.px10};
        margin-bottom: ${theme.spacing.px10};
    `}
`;

const FirstElement = styled('div')`
  width: 97px;
  flex-direction: row;
  display: flex;
  align-items: center;
`;

const SecondElement = styled('div')`
  flex-direction: row;
  display: flex;
  align-items: center;
`;

const ValueDonate = styled('div')`
  width: fit-content;
  padding-left: 13px;
`;

const ValueLink = styled('div')`
  width: fit-content;
  padding-left: 10px;
`;

class Footer extends Component {
  render() {
    const {
      props: {
        media,
        reach,
        loadPreviews,
        openEdit,
        showPreviewModal,
        showEditModal,
        feedType,
        insightsTransformed,
        periodTransformed,
        closeModal,
        canEditAd,
        genericReducer: { feedChannel },
        authenticationReducer: { subDomain },
      },
    } = this;

    let hasEllipsisButton = false;

    if (media.link_url) {
      // Adicionar outras condicionais caso haja novos menus posteriormente.
      hasEllipsisButton = true;
    }

    return (
      <Wrapper>
        <EllipsisButton
          media={media}
          loadPreviews={loadPreviews}
          isInstagram={feedType === 'INSTAGRAM_STORIES' || feedChannel === 'instagram'}
          openEdit={openEdit}
          feedType={feedType}
          canEditAd={canEditAd}
        />
        <Info
          full={!hasEllipsisButton}
          idAd={feedType === 'AD'}
          isInstagram={
            feedType === 'INSTAGRAM_STORIES' || (feedType === 'POST' && feedChannel === 'instagram')
          }
        >
          {subDomain.sub_domain === 'kroton' ? (
            <>
              <div className="first-content">
                {feedType === 'INSTAGRAM_STORIES' ||
                (feedType === 'POST' && feedChannel === 'instagram') ? (
                  <>
                    <div title={media.like_count}>
                      <FontAwesomeIcon style={{ color: '#6A51A8' }} icon={['fal', 'thumbs-up']} />
                      {handleValueTooBig(media.like_count)}
                    </div>
                    <div>
                      <FontAwesomeIcon style={{ color: '#6A51A8' }} icon={['fal', 'clock']} />
                      {dayjs(new Date(media.timestamp)).format('DD/MM/YY - HH:mm')}
                    </div>
                  </>
                ) : (
                  <>
                    <div title={insightsTransformed.thumbsValue}>
                      <FontAwesomeIcon style={{ color: '#6A51A8' }} icon={['fal', 'thumbs-up']} />
                      {handleValueTooBig(insightsTransformed.thumbsValue)}
                    </div>

                    {!!media.reach || media.reach === '0' ? (
                      <div title={reach}>
                        <FontAwesomeIcon
                          style={{ color: '#6A51A8' }}
                          icon={['fal', 'user-friends']}
                        />
                        {handleValueTooBig(media.reach)}
                      </div>
                    ) : (
                      <div title={insightsTransformed.printValue}>
                        <FontAwesomeIcon style={{ color: '#6A51A8' }} icon={['fas', 'print']} />
                        {handleValueTooBig(insightsTransformed.printValue)}
                      </div>
                    )}

                    <div title={insightsTransformed.pointerValue}>
                      <FontAwesomeIcon
                        style={{ color: '#6A51A8' }}
                        icon={['fal', 'mouse-pointer']}
                      />
                      {handleValueTooBig(insightsTransformed.pointerValue)}
                    </div>

                    {/* <>
                                        <ButtonLink onClick={() => loadPreviews(media.id)}>{t('SEE_MORE')}</ButtonLink>
                                    </> */}
                  </>
                )}
              </div>
              {feedType === 'INSTAGRAM_STORIES' ||
              (feedType === 'POST' && feedChannel === 'instagram') ? null : (
                <SecondContentWrapper>
                  <FirstElement title={insightsTransformed.linkValue}>
                    <FontAwesomeIcon style={{ color: '#6A51A8' }} icon={['fal', 'link']} />
                    <ValueLink>{handleValueTooBig(insightsTransformed.linkValue)}</ValueLink>
                  </FirstElement>
                  <SecondElement title={insightsTransformed.linkValue}>
                    <FontAwesomeIcon style={{ color: '#6A51A8' }} icon={['fal', 'donate']} />
                    <ValueDonate>
                      {handleValueTooBig(insightsTransformed.conversionPurchaseValue)}
                    </ValueDonate>
                  </SecondElement>
                </SecondContentWrapper>
              )}
            </>
          ) : (
            <div className="first-content">
              {feedType === 'INSTAGRAM_STORIES' ||
              (feedType === 'POST' && feedChannel === 'instagram') ? (
                <>
                  <div title={media.like_count}>
                    <FontAwesomeIcon style={{ color: '#6A51A8' }} icon={['fal', 'thumbs-up']} />
                    {handleValueTooBig(media.like_count)}
                  </div>
                  <div>
                    <FontAwesomeIcon style={{ color: '#6A51A8' }} icon={['fal', 'clock']} />
                    {dayjs(new Date(media.timestamp)).format('DD/MM/YY - HH:mm')}
                  </div>
                </>
              ) : (
                <>
                  <div title={insightsTransformed.thumbsValue}>
                    <FontAwesomeIcon style={{ color: '#6A51A8' }} icon={['fal', 'thumbs-up']} />
                    {handleValueTooBig(insightsTransformed.thumbsValue)}
                  </div>

                  {!!media.reach || media.reach === '0' ? (
                    <div title={reach}>
                      <FontAwesomeIcon
                        style={{ color: '#6A51A8' }}
                        icon={['fal', 'user-friends']}
                      />
                      {handleValueTooBig(media.reach)}
                    </div>
                  ) : (
                    <div title={insightsTransformed.printValue}>
                      <FontAwesomeIcon style={{ color: '#6A51A8' }} icon={['fas', 'print']} />
                      {handleValueTooBig(insightsTransformed.printValue)}
                    </div>
                  )}

                  <div title={insightsTransformed.pointerValue}>
                    <FontAwesomeIcon style={{ color: '#6A51A8' }} icon={['fal', 'mouse-pointer']} />
                    {handleValueTooBig(insightsTransformed.pointerValue)}
                  </div>

                  <div title={insightsTransformed.linkValue}>
                    <FontAwesomeIcon style={{ color: '#6A51A8' }} icon={['fal', 'link']} />
                    {handleValueTooBig(insightsTransformed.linkValue)}
                  </div>

                  {/* <>
                                    <ButtonLink onClick={() => loadPreviews(media.id)}>{t('SEE_MORE')}</ButtonLink>
                                </> */}
                </>
              )}
            </div>
          )}

          {feedType === 'AD' && (
            <AdDataWrapper>
              <div>{numeral(insightsTransformed.spendValue).format('$ 0,0.00')}</div>
              {periodTransformed && (
                <div>
                  <FontAwesomeIcon
                    icon={['far', 'calendar-alt']}
                    style={{ marginRight: '6px', color: '#6A51A8' }}
                  />
                  {periodTransformed}
                </div>
              )}
            </AdDataWrapper>
          )}
        </Info>

        <PreviewModal
          feedType={feedType}
          showPreviewModal={showPreviewModal}
          media={media}
          closeModal={closeModal}
        />

        <EditModal
          feedType={feedType}
          showEditModal={showEditModal}
          media={media}
          closeModal={closeModal}
        />
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    authenticationReducer: state.authenticationReducer,
    genericReducer: state.genericReducer,
  };
}

export default connect(mapStateToProps)(translate('MediaCards')(Footer));
